import { createTypes } from 'reduxsauce';



export default createTypes(`

    GET_S3_ACCESS
    RESPONSE_S3_ACCESS

    SEND_EMAIL
    MAKE_CALL

    RESPONSE_COVID_GOOGLE_RSS_FEED_IMAGE
    GET_COVID_GOOGLE_RSS_FEED_IMAGES
    GET_COVID_GOOGLE_RSS_FEED_SINGLE_IMAGE
    RESPONSE_COVID_GOOGLE_RSS_FEED_SINGLE_IMAGE

    GET_COVID_GOOGLE_RSS_FEED
    RESPONSE_COVID_GOOGLE_RSS_FEED

    GET_COVID_DECLARATION_OVERALL_SYMPTOMS_V2
    RESPONSE_COVID_DECLARATION_OVERALL_SYMPTOMS_V2

    UPDATE_USER_PROFILE
    
    CHANGE_USER_PROFILE_MODAL_STATE

    GET_GLOBAL_COVID_DASHBOARD
    RESPONSE_GLOBAL_COVID_DASHBOARD
    
    POST_INVITATION_LINK
    POST_INVITATION_LINK_VIA_PHONE

    PUT_INVITATION_LINK_SUCCESS
    HANDLE_INVITATION_REQUEST

    LOGIN_USING_INVITATION_LINK
    LOGIN_RESPONSE_INVITATION_LINK
    
    GET_ORGANIZATION
    STORE_ORGANIZATION
    
    CHANGE_CURRENT_LOCATION

    GET_COVID_DECLARATION_LIST
    RESPONSE_COVID_DECLARATION_LIST

    SET_LOADER
    UNSET_LOADER
    
    UPLOAD_DOCUMENTS
    ADD_CONTENT_ID
    FETCH_DOCUMENTS

    POST_COVID_DECLARATION_FORM
    RESPONSE_COVID_DECLARATION_FORM
    
    SET_HSG_BANNER_FLAG
    POST_PARENT_LINKED_IN
    UPDATE_PARENT_INFO

    VERIFY_UNREGISTERED_OTP    
    SIGNUP_USER_V2_1
    PARENT_UPDATE_RESPONSE
    
    UPDATE_PARENT_INFO
    SEND_STUDENT_VERIFICATION_EMAIL
    
    PUT_USER_ASSOCIATION
    HIDE_STUDENT_VERIFICATION_MODAL

    SEND_MAGIC_LINK
    RESPONSE_MAGIC_LINK

    FETCH_USER_SIGNUP_STATUS
    STORE_USER_SIGNUP_STATUS

    UPDATE_SELECTED_CHILD_ON_UPDATE
    
    CHANGE_MAGIC_LINK_STATUS

    LOGIN_USING_MAGIC_LINK
    LOGIN_RESPONSE_MAGIC_LINK

    RESPONSE_RESET_ACTIVATION_CODE
    RESET_ACTIVATION_CODE

    RESPONSE_ADD_CHILD_USING_ACTIVATION_CODE_WITHOUT_DOB
    ADD_CHILD_USING_ACTIVATION_CODE_WITHOUT_DOB

    VERIFY_AVAILABILITY_EMAIL
    RESPONSE_AVAILABILITY_EMAIL

    CHECK_EMAIL_AVAILABILITY
    CHECK_PHONE_NUMBER_AVAILABILITY
    CHECK_ACTIVATION_CODE_AVAILABILITY

    RESPONSE_CHECK_EMAIL_AVAILABILITY
    RESPONSE_CHECK_PHONE_NUMBER_AVAILABILITY
    RESPONSE_CHECK_ACTIVATION_CODE_AVAILABILITY

    RESPONSE_CHANGE_VALIDATION_RESPONSE_TYPE
    CHANGE_VALIDATION_RESPONSE_TYPE

    VERIFY_AVAILABILITY_PHONE
    RESPONSE_AVAILABILITY_PHONE

    RESET_AVAILABILITY_CODE
    VERIFY_AVAILABILITY_CODE
    RESPONSE_AVAILABILITY_CODE

    SIGNUP_USER
    SIGNUP_USER_V2
    SIGNUP_RESPONSE

    LOGIN_USER
    LOGIN_RESPONSE
    LOGOUT_USER

    GET_GLOSSARY
    STORE_GLOSSARY
    CHANGE_PASSWORD

    UPDATE_USER
    RESPONSE_UPDATE_USER
    RESPONSE_UPDATE_CHILD_USER

    GET_USER

    SEND_OTP

    SEND_OTP_PHONE
    RESPONSE_SEND_OTP_PHONE

    VERIFY_OTP
    RESPONSE_VERIFY_OTP

    INITIALIZE_FORM

    FETCH_CHILD_LIST
    RESPONSE_CHILD_LIST

    ADD_CHILD_USING_ACTIVATION_CODE
    RESPONSE_ADD_CHILD_USING_ACTIVATION_CODE

    SELECT_CHILD

    FETCH_STUDENT_ASSESSMENT_STATUS
    RESPONSE_STUDENT_ASSESSMENT_STATUS

    FETCH_PENTAHO_REPORT
    RESPONSE_PENTAHO_REPORT

    DOWNLOAD_PENTAHO_REPORT

    RESET_EXPERT_QUERIES
    POST_EXPERT_QUERIES
    RESPONSE_EXPERT_QUERIES

    FETCH_COUNTRIES
    RESPONSE_COUNTRIES
    FETCH_STATES
    RESPONSE_STATES
    FETCH_CITIES
    RESPONSE_CITIES
    FETCH_PARTNERS
    RESPONSE_PARTNERS
    FETCH_SPECIALITIES
    RESPONSE_SPECIALITIES
    FETCH_OFFERS
    RESPONSE_OFFERS

    FETCH_VACCINATION
    RESPONSE_VACCINATION

    RESET_APPOINTMENT_REQUEST
    DRA_DROPDOWN_SELECT
    DRA_CHANGE_REQUEST
    POST_APPOINTMENT_REQUEST
    RESPONSE_APPOINTMENT_REQUEST

    GET_DMFT_INDEX
    UPDATE_DMFT_INDEX

    SHOW_SIDEBAR
    HIDE_SIDEBAR
    SET_COVID_DATA
    CHANGE__USER__LOCATION
    RESET__LOGIN__RESPONSE
`)